import { I18nValue } from '@lib/types';
import { useTranslation } from '@providers/I18n';

export function useI18nValue(value: I18nValue | null | undefined): string {
  const { i18n } = useTranslation();

  if (!value) {
    return '';
  }

  if (i18n.language === 'ar') {
    return value.ar;
  }

  return value.en;
}
